import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';
import { calculateHeight } from '../statisticsParentUtils';

export const StatisticsWorkMaterialsTwo = ({ obj, text, textTop, allUsers }) => {
  const { t } = useTranslation();

  const userCount = Array.isArray(allUsers) ? allUsers.length : allUsers;

  const maxAverageValue = 12;

  return (
    <div className="statistics-work-materials-block">
      <div className="statistics-work-materials-block-top">
        <div className="statistics-work-materials-text">
          <span className="statistics-work-materials-count">
            {Math.round(obj.totalSessionsCount / userCount)} {t(textTop)}
          </span>
          <span className="statistics-work-materials-count-text">{t(text)}</span>
        </div>
      </div>

      <div className="statistics-work-materials-block-bottom">
        <ul className="statistics-work-materials-list">
          {Object.entries(obj)
            .filter(([key, value]) => key.includes('Month') && typeof value === 'object')
            .map(([key, value]) => {
              const averageCount = Math.round(value.count / userCount);
              return (
                <li key={key}>
                  <div
                    className="pilar-item"
                    style={{
                      height: calculateHeight(averageCount, maxAverageValue) + '%',
                    }}
                  >
                    <div className="pilar-count">{averageCount}</div>
                  </div>
                  <div className="pilar-month">
                    <span>{t(value.month)}.</span>
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};
